
define('modules/application/wizard/steps/zoneStep/thermoZoneStep',[
    "app",

    // Libs
    "backbone",
    "jqueryUi",

    //Class
    "./complexZoneStep",
    "./thermoZoneStep/zoneModel",
    "./thermoZoneStep/zoneCollection",
    "./thermoZoneStep/zoneDetailView",
    "./thermoZoneStep/zonesMenuView",
    "../../classes/accessoryLine",
    "../../classes/mainControlUnit",
    "../../classes/outerRadioProbe",
    "../../classes/pumps",
    "../../classes/solenoidValves",
    "../../classes/probes",
    "../../classes/ecoMode"
  ],

  function(
    app,
    Backbone,
    jQueryUi,
    ZoneStep,
    ZoneModel,
    ZoneCollection,
    ZoneDetailView,
    ZonesMenuView,
    accessoryLine,
    mainControlUnit,
    outerRadioProbe,
    pumps,
    solenoidValves,
    probes,
    ecoMode) {

    var thermoZoneStepModel = ZoneStep.Model.extend({

      addConstructors: function() {
        ZoneStep.Model.prototype.addConstructors.apply(this);
        this.ZoneModel = ZoneModel;
        this.ZoneCollection = ZoneCollection;
      },

      initialize: function() {
        this.addConstructors();
        window.BticinoS4B.eventAggregator.unbind("mainControlUnit:selected", this.mainControlUnitSelectedEventHandler);
        window.BticinoS4B.eventAggregator.bind("mainControlUnit:selected", this.mainControlUnitSelectedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("mainControlUnit:removed", this.mainControlUnitRemovedEventHandler);
        window.BticinoS4B.eventAggregator.bind("mainControlUnit:removed", this.mainControlUnitRemovedEventHandler, this);

        this.get("stepEventAggregator").unbind('collection:validated', this.collectionValidatedEventHandler);
        this.get("stepEventAggregator").bind('collection:validated', this.collectionValidatedEventHandler, this);

        this.get("stepEventAggregator").unbind('collection:unvalidated', this.collectionUnvalidatedEventHandler);
        this.get("stepEventAggregator").bind('collection:unvalidated', this.collectionUnvalidatedEventHandler, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

        window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

        window.BticinoS4B.eventAggregator.unbind("mainControlUnit:chosen", this.mainControlUnitChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind("mainControlUnit:chosen", this.mainControlUnitChosenEventHandler, this);

        this.instanceCollection();
      },

      mainControlUnitChosenEventHandler: function(e) {
        if(this.collection.at(0).get("probesModel")){
          if (this.collection.at(0).get("probesModel").attributes) {
            if (BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") == 4)
              this.collection.at(0).fourZonesMainControlUnitChosen();
            else
              this.collection.at(0).mainControlUnitChosen();
          }
        }
      },

      collectionValidatedEventHandler: function() {
        this.get("stepEventAggregator").trigger("step:validated", this);
      },

      collectionUnvalidatedEventHandler: function() {
        this.get("stepEventAggregator").trigger("step:unvalidated", this);
      },

      instanceCollection: function() {
        this.collection = new this.ZoneCollection([], {
          stepEventAggregator: this.get("stepEventAggregator")
        });
        this.addZone(null);
        this.get("stepEventAggregator").trigger("collection:initialized");
      },

      deliverSolenoidValves: function(zoneNumber, zoneName, modelToDeliver) {
        var combinedPlant = modelToDeliver.get("combinedPlant"),
          heatingPlant = modelToDeliver.get("heatingPlant"),
          breezingPlant = modelToDeliver.get("breezingPlant"),
          dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
          fetchedTypes = modelToDeliver.fetchedTypes,
          itemsToAdd = [],
          i = 0;

        /*-------------*/
        /*COMBINEDPLANT*/
        /*-------------*/
        for (i = 0; i < fetchedTypes.length; i++) {
          if (fetchedTypes[i].packageClassId === modelToDeliver.get("combinedPlant").type) {
            _.extend(modelToDeliver.get("combinedPlant"), fetchedTypes[i]);
            break;
          }
        }

        /*------------*/
        /*HEATINGPLANT*/
        /*------------*/
        for (i = 0; i < fetchedTypes.length; i++) {
          if (fetchedTypes[i].packageClassId === modelToDeliver.get("heatingPlant").type) {
            _.extend(modelToDeliver.get("heatingPlant"), fetchedTypes[i]);
            break;
          }
        }

        /*------------*/
        /*BREEZINGPLANT*/
        /*------------*/
        for (i = 0; i < fetchedTypes.length; i++) {
          if (fetchedTypes[i].packageClassId === modelToDeliver.get("breezingPlant").type) {
            _.extend(modelToDeliver.get("breezingPlant"), fetchedTypes[i]);
            break;
          }
        }

        if (modelToDeliver.get("combinedPlantType")) {
          if (modelToDeliver.get("combinedPlant").quantity > 0)
            itemsToAdd.push({
              productCode: modelToDeliver.get("combinedPlant").productCode,
              productLabel: modelToDeliver.get("combinedPlant").productLabel,
              packageClassLabel: modelToDeliver.get("combinedPlant").packageClassLabel,
              kitValue: modelToDeliver.get("combinedPlant").kitValue,
              partOfKit: modelToDeliver.get("combinedPlant").partOfKit,
              quantity: modelToDeliver.get("combinedPlant").quantity,
              price: modelToDeliver.get("combinedPlant").price
            });
        } else {
          if (modelToDeliver.get("heatingPlant").quantity > 0)
            itemsToAdd.push({
              productCode: modelToDeliver.get("heatingPlant").productCode,
              productLabel: modelToDeliver.get("heatingPlant").productLabel,
              packageClassLabel: modelToDeliver.get("heatingPlant").packageClassLabel,
              kitValue: modelToDeliver.get("heatingPlant").kitValue,
              partOfKit: modelToDeliver.get("heatingPlant").partOfKit,
              quantity: modelToDeliver.get("heatingPlant").quantity,
              price: modelToDeliver.get("heatingPlant").price
            });

          if (modelToDeliver.get("breezingPlant").quantity > 0)
            itemsToAdd.push({
              productCode: modelToDeliver.get("breezingPlant").productCode,
              productLabel: modelToDeliver.get("breezingPlant").productLabel,
              packageClassLabel: modelToDeliver.get("breezingPlant").packageClassLabel,
              kitValue: modelToDeliver.get("breezingPlant").kitValue,
              partOfKit: modelToDeliver.get("breezingPlant").partOfKit,
              quantity: modelToDeliver.get("breezingPlant").quantity,
              price: modelToDeliver.get("breezingPlant").price
            });
        }

        dataProvider.addItemsToZone(zoneNumber, zoneName, itemsToAdd);

      },

      deliverProbes: function(zoneNumber, zoneName, modelToDeliver) {
        var itemsToAdd = [],
          dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");

        if (!modelToDeliver.get("useMainControlUnitAsMasterProbe")) {

          //Master probes
          itemsToAdd.push({
            productCode: modelToDeliver.get("productCode"),
            productLabel: modelToDeliver.get("productLabel"),
            packageClassLabel: modelToDeliver.get("packageClassLabel"),
            kitValue: modelToDeliver.get("kitValue"),
            partOfKit: modelToDeliver.get("partOfKit"),
            quantity: 1,
            price: modelToDeliver.get("price"),
            type:'masterProbe'
          });

        }

        //Slave probes
        itemsToAdd.push({
          productCode: modelToDeliver.get("slaveProbesDetails").productCode,
          productLabel: modelToDeliver.get("slaveProbesDetails").productLabel,
          packageClassLabel: modelToDeliver.get("slaveProbesDetails").packageClassLabel,
          kitValue: modelToDeliver.get("slaveProbesDetails").kitValue,
          partOfKit: modelToDeliver.get("slaveProbesDetails").partOfKit,
          quantity: modelToDeliver.get("slaveProbes") ? modelToDeliver.get("slaveProbes") : 0,
          price: modelToDeliver.get("slaveProbesDetails").price,
          type:'slaveProbe'
        });

        dataProvider.addItemsToZone(zoneNumber, zoneName, itemsToAdd);
      },

      deliverEcoMode: function(zoneNumber, zoneName, modelToDeliver) {

      },

      deliverZone: function(zoneToDeliver) {
        this.deliverSolenoidValves(zoneToDeliver.get("number"), zoneToDeliver.get("name"), zoneToDeliver.get("solenoidValvesModel"));
        this.deliverProbes(zoneToDeliver.get("number"), zoneToDeliver.get("name"), zoneToDeliver.get("probesModel"));
        this.deliverEcoMode(zoneToDeliver.get("number"), zoneToDeliver.get("name"), zoneToDeliver.get("ecoModeModel"));
      },

      deliverModel: function() {
        BticinoS4B.solution.thermoregulation.zones = this;
        BticinoS4B.Instances.Models.ApplicationModel.set("zones", BticinoS4B.solution.thermoregulation.zones);
        var zoneCollection = this.collection,
          zoneCollectionLenght = zoneCollection.length;

        for (var i = 0; i < zoneCollectionLenght; i++)
          this.deliverZone(zoneCollection.models[i]);

      },

      duplicateSelectedZone: function() {
        var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;

        if (this.collection.length < maxZoneNumber) {
          var selectedModel = this.collection.filter(function(currentModel) {
            return currentModel.get("selected");
          });

          if ((selectedModel.length > 0) && (!selectedModel[0].get("probesModel").get("useMainControlUnitAsMasterProbe"))) {
            //Creating base model
            var modelToAdd = new this.ZoneModel(
              _.extend(
                selectedModel[0].toJSON(), {
                  number: this.collection.length + 1
                }
              )
            );

            var k = 2;
            var nameFound;
            while (!nameFound) {
              for (var i = 0; i < this.collection.models.length; i++) {
                if (modelToAdd.get("name").indexOf('{defaultName}') === 0) {
                  modelToAdd.set("name", '{defaultName} ' + modelToAdd.get("number"));
                  nameFound = true;
                  break;
                } else {
                  if (this.collection.models[i].get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003")) == (modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003")) + "(" + k + ")")) {
                    break;
                  } else {
                    if (i == this.collection.models.length - 1) {
                      nameFound = true;
                      modelToAdd.set("name", modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003")) + "(" + k + ")");
                    }
                  }
                }
              }
              if (!nameFound)
                k++;
            }

            //

            //////////////////////////////////
            //Creating new solenoidValvesModel
            //////////////////////////////////
            var solenoidValvesModelToAdd = new solenoidValves.Model(
              $.extend({}, {
                stepEventAggregator: this.get("stepEventAggregator")
              }, modelToAdd.get("solenoidValvesModel")).toJSON()
            );
            modelToAdd.set("solenoidValvesModel", solenoidValvesModelToAdd);

            //////////////////////////////////
            //Creating new probesModel
            //////////////////////////////////
            var probesModelToAdd = new probes.Model(
              $.extend({}, {
                stepEventAggregator: this.get("stepEventAggregator")
              }, modelToAdd.get("probesModel")).toJSON()
            );
            modelToAdd.set("probesModel", probesModelToAdd);

            //////////////////////////////////
            //Creating new ecoModeModel
            //////////////////////////////////
            var ecoModeModelToAdd = new ecoMode.Model(
              $.extend({}, {
                stepEventAggregator: this.get("stepEventAggregator")
              }, modelToAdd.get("ecoModeModel")).toJSON()
            );

            modelToAdd.set("ecoModeModel", ecoModeModelToAdd);

            //Adding new model to the collection
            this.addZone(modelToAdd);
            this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
          } else {
            alert($.i18n._("IDS_W1_9091"));
          }

        } else {
          alert($.i18n._("IDS_W1_9090"));
        }
      },

      removeZone: function(zoneToRemove) {
        if (!zoneToRemove.get("probesModel").get("useMainControlUnitAsMasterProbe"))
          this.collection.remove(zoneToRemove);
        else
          alert($.i18n._("IDS_W1_9105"));
      },

      mainControlUnitSelectedEventHandler: function(model, event, maxZoneNumber) {
        var toReturn = true;
        var mustRemoveZones = false;

        //If I am passing from a 99zones central to 4zones one
        if (this.collection.length > maxZoneNumber) {

          //If there are more than maxZoneNumber zones
          if (confirm($.i18n._("IDS_W1_9092", [(maxZoneNumber + 1), this.collection.length])))
            mustRemoveZones = true;
          else
            toReturn = false;
        }


        //If the new MCU is a 4zones one
        if ((toReturn) && (maxZoneNumber == 4)) {

          //If there's one Climaveneta product at least
          if (this.collection.thereIsOneClimavenetaProductAtLeast()) {
            if (confirm($.i18n._("IDS_W1_9080"))) {

              //If there's one eco function activated at least
              if (this.collection.thereIsOneEcoFunctionActivatedAtLeast()) {
                if (confirm($.i18n._("IDS_W1_9081"))) {

                  this.collection.disableAllEcoFunctions();
                  this.collection.removeClimavenetaProducts();

                } else
                  toReturn = false;
              } else {
                this.collection.removeClimavenetaProducts();
              }
            } else
              toReturn = false;
          } else {
            if (this.collection.thereIsOneEcoFunctionActivatedAtLeast()) {
              if (confirm($.i18n._("IDS_W1_9081"))) {
                this.collection.disableAllEcoFunctions();
              } else
                toReturn = false;
            }
          }
        }

        //Remove zones in excess
        if (mustRemoveZones)
          for (var i = this.collection.length - 1; i >= maxZoneNumber; i--)
            this.removeZone(this.collection.models[i]);

        if (toReturn)
          window.BticinoS4B.eventAggregator.trigger("mainControlUnit:changeApproved", event);
        else
          window.BticinoS4B.eventAggregator.trigger("mainControlUnit:changeNotApproved", event);
      }
    });

    var thermoZoneStepViews = _.extend({}, ZoneStep.Views);
    var thermoZoneStepContentView = thermoZoneStepViews.Content.extend({
      addConstructors: function() {
        ZoneStep.Views.Content.prototype.addConstructors.apply(this);
        this.ZoneDetailView = ZoneDetailView;
        this.ZonesMenuView = ZonesMenuView;
      }
    });

    thermoZoneStepViews.Content = thermoZoneStepContentView;

    //Creating final ZoneStep class
    var thermoZoneStep = _.extend({}, ZoneStep, {
      objClass: "thermoZones",
      Model: thermoZoneStepModel,
      Views: thermoZoneStepViews
    });

    // Required, return the module for AMD compliance
    return thermoZoneStep;

  });